import "./styles.scss"

import React from "react"
import clsx from "clsx"

type Props = {
  className?: string
  color?: "blue" | "gray"
  bgColor?: "white" | "gray" | "blue"
  children: JSX.Element | JSX.Element[]
}

const mainClassName = "rounded-wrapper"

const RoundedWrapper = ({
  className,
  color = "blue",
  bgColor = "white",
  children,
}: Props) => {
  return (
    <div className={clsx(mainClassName, getColorClassName(color))}>
      <div
        className={clsx(
          className,
          `${mainClassName}__edges`,
          getBgColorClassName(bgColor)
        )}
      >
        <div className="container">{children}</div>
      </div>
    </div>
  )
}

const getColorClassName = (color: Props["color"]) => {
  switch (color) {
    case "blue":
      return `${mainClassName}--blue`
    case "gray":
      return `${mainClassName}--gray`
    default:
      return ""
  }
}

const getBgColorClassName = (color: Props["bgColor"]) => {
  switch (color) {
    case "white":
      return `${mainClassName}__edges--white`
    case "gray":
      return `${mainClassName}__edges--gray`
      case "blue":
        return `${mainClassName}__edges--blue`
    default:
      return ""
  }
}

export default RoundedWrapper
